import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

/* eslint-disable-next-line @unicorn/consistent-function-scoping */
export const passwordValidator = (): ValidatorFn => (control: AbstractControl<string>): ValidationErrors | null => {
  const value: string = control.value;

  return (/^(?=.*[A-Z])(?=.*[a-z]).+$/).test(value)
    ? null
    : {
      format: true
    };
};
export const passwordMatchValidator = (matchingControlName: string): ValidatorFn => (control: AbstractControl<string>): ValidationErrors | null => {
  const parentControl: FormGroup | FormArray | null = control.parent;
  const matchingControl: AbstractControl<string, string> | null | undefined = parentControl?.get(matchingControlName);

  if (matchingControl === null || matchingControl === undefined)
    return null;

  return matchingControl.value === control.value
    ? null
    : {
      match: true
    };
};
